import React from 'react';
import classnames from 'classnames';
import { TextButton } from '../../../audi-ui-components/Button';

class Offer extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            dOpen: false,
            dHeight: 800
        }
        this.refDisclaimer = React.createRef();
    }

    toggle = () => {
        var o = !this.state.dOpen;
        var h = this.refDisclaimer.current.offsetHeight + 30;
        this.setState({ dOpen: o, dHeight: h });
    }

    render() {
        const {offer} = this.props;
        return (
            <div className="offer p-4 mb-4 aui-color-gray85">
                <p className="aui-headline-3 mb-3">{offer.title}</p>
                <p className="aui-headline-5 mb-3">{offer.shortDescription}</p>
                <div dangerouslySetInnerHTML={{__html: offer.description}} />
                <div className={classnames("offer-disclaimer mt-3", {"open": this.state.dOpen, "closed": !this.state.dOpen})}>
                    <p><TextButton label={offer.disclaimerTitle || "Disclaimer"} onClick={this.toggle} /></p>
                    <div className="offer-disclaimer__content" style={{maxHeight: this.state.dOpen ? `${this.state.dHeight}px` : "0"}}>
                        <div ref={this.refDisclaimer}>
                            <div className="aui-small" dangerouslySetInnerHTML={{__html: offer.disclaimer}} />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Offer;
